/**
 * Post Recommend API
 * Server: GET/POST/DELETE /api/v1/posts/{board_id}/{post_id}/recommends
 */

import { ApiBase } from "../../core/api-base";
import { z } from "zod";
import { UpsertRecommendForPostBody } from "../../api/generated/posts.zod";

type UpsertPostRecommendRequest = z.infer<typeof UpsertRecommendForPostBody>;

class PostRecommendApi extends ApiBase {
    public static async getMeta(boardId: string, postId: number): Promise<Response> {
        return await super.apiGet(`/api/v1/posts/${boardId}/${postId}/recommends`, { noSpinner: true });
    }

    public static async upsert(boardId: string, postId: number, rank: number | null): Promise<Response> {
        const payload: UpsertPostRecommendRequest = {
            rank: rank === null ? null : Number(rank),
        };

        return await super.apiPost(`/api/v1/posts/${boardId}/${postId}/recommends`, payload, { noSpinner: true });
    }

    public static async remove(boardId: string, postId: number): Promise<Response> {
        return await super.apiDelete(`/api/v1/posts/${boardId}/${postId}/recommends`, { noSpinner: true });
    }

    public static async clearAll(boardId: string): Promise<Response> {
        return await super.apiDelete(`/api/v1/posts/${boardId}/recommends/clear`, { noSpinner: true });
    }
}

export { PostRecommendApi };
